import supabaseClient from "./supabaseClient";

function generatePublicUrlOfImage(imageName, folderName) {
  const filePath = `${folderName}/${imageName}`;
  return supabaseClient.storage.from("file_upload").getPublicUrl(filePath);
}

export default generatePublicUrlOfImage;
